import { PERU, DOCUMENT_NUMBER_CLEAN_REGEX } from "../../constants";

const RucFormatter = ruc => {
    return ruc.replace(DOCUMENT_NUMBER_CLEAN_REGEX[PERU.value], '');
}

export default RucFormatter